// extracted by mini-css-extract-plugin
module.exports = {"swiper":"swiper_swiper__tjdkF"};